import React from 'react'
import { useNavigate } from 'react-router-dom';
const Dbnav = () => {
    var nav=useNavigate()
    function navigateProfile(){
        nav('/Profile')
      }
      function navigatePanel(){
        nav('/DeliveryBoyPanel')
      }
  return (
    <>
    <div className='row navi gx-0 my-2'>
    <div className='col-lg-2 col-md-2 usernav'>
    <img src='https://res.cloudinary.com/vcart/image/upload/v1653901249/Screenshot__131_-removebg-preview_v1bpdc.png' style={{height:"30px", marginTop:"3px"}} alt="VCART" onClick={()=>navigatePanel()} />
    </div>
    <div className='col-lg-2  col-md-2 HubIcons my-auto'>
    <a onClick={()=>navigatePanel()}><i className="fas fa-box mx-3"></i></a> 
    <a onClick={()=>navigateProfile()}><i className="fas fa-user-circle mx-3"></i></a>
    </div>
    </div>
    </>
  )
}

export default Dbnav